import { useState } from "react";
import { deleteRegistereintrag, updateRegistereintrag } from "../services/apiService";
import { parseCurrencyInput } from "../utils/formatUtils";

export const useRegisterEintragActions = (entry, onUpdate, label) => {
    const [actionLoading, setActionLoading] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState('delete'); // 'delete' | 'edit'
    const [selectedItem, setSelectedItem] = useState(null);

    const handleDeleteClick = (item) => {
        setSelectedItem(item);
        setModalMode('delete');
        setModalOpen(true);
    };

    const handleEditClick = (item) => {
        setSelectedItem(item);
        setModalMode('edit');
        setModalOpen(true);
    };

    const handleModalConfirm = async ({ betrag, bemerkung }) => {
        if (!selectedItem) return;

        setModalOpen(false);
        setActionLoading(selectedItem.id);

        try {
            const parsedBetrag = parseCurrencyInput(betrag);
            if (modalMode === 'delete') {
                await deleteRegistereintrag(entry.id, selectedItem.id, { betrag: parsedBetrag, bemerkung });
                if (onUpdate) {
                    await onUpdate(`${label} Nr. ${selectedItem.laufendeNr} wurde erfolgreich gelöscht.`);
                }
            } else {
                await updateRegistereintrag(entry.id, selectedItem.id, { betrag: parsedBetrag, bemerkung });
                if (onUpdate) {
                    await onUpdate(`${label} Nr. ${selectedItem.laufendeNr} wurde erfolgreich aktualisiert.`);
                }
            }
        } catch (error) {
            console.error(`Fehler beim ${modalMode === 'delete' ? 'Löschen' : 'Bearbeiten'} des Eintrags:`, error);
            if (onUpdate) {
                await onUpdate(error);
            }
        } finally {
            setActionLoading(null);
            setSelectedItem(null);
        }
    };

    const handleModalCancel = () => {
        setModalOpen(false);
        setSelectedItem(null);
    };

    return {
        actionLoading,
        modalOpen,
        modalMode,
        selectedItem,
        handleDeleteClick,
        handleEditClick,
        handleModalConfirm,
        handleModalCancel
    };
};
